<template>  
    <section>
		<div class="list" :style="{ height: wrapperHeight + 'px' }">
			<mt-loadmore v-if="balanceList && balanceList.length" :bottom-method="loadBottom" :auto-fill="false" :bottom-all-loaded="allLoaded" ref="loadmore" :bottomPullText='"加载更多"' :bottomLoadingText='"加载中"' :bottomDropText='"释放加载"'>
				<ul>
					<li class="news-wrap" v-for="(item,index) of balanceList" :key="index" @click="toBalanceDetail(item)">
						<div class="balance-money">
							<span class="text">{{item.describe}}</span>
							<span class="time">{{item.create_time}}</span>
						</div>
						
						<div class="balance-money">
							<span class="balance">余额：<span class="balance">{{item.now_balance}}</span></span>
							<span class="count-money">
								<span class="money" v-text='item.type === "1"?"+":"-"'></span>
								<span class="money">{{ item.amount }}</span>
							</span>
						</div>

					</li>
				</ul>
			</mt-loadmore>
			
			<div v-else>
				<div class="no-order">
					<img src="../../assets/images/no-detail.png">
					<p>暂无余额明细</p>
				</div>
			</div>
		</div>
    </section>
</template>
<script>
import CommonHeader from '@/components/CommonHeader'
import { getBalanceRecord } from '@/api/wallet'

export default {
	name: 'Balance',
	components: {
		CommonHeader
	},
	
	data() {
		return {
			wrapperHeight:0,
			allLoaded:false,
			balanceList: [],
			body: {
				page_index: 1,
				page_size: 10,
			},
		}
	},
	
	beforeCreate(){
		sessionStorage.setItem("roleType","customer")
	},

	created() {
		this.getBalanceList();
	},
	
	mounted(){
	    this.wrapperHeight = document.documentElement.clientHeight;
        document.title = "余额明细"
	},
    
	methods: {
		toBalanceDetail(item) {
			this.$router.push({
				path: '/balance-detail',
				query: {
					data: item
				}
			})
		},
		
		async getBalanceList() {
			const { data, status } = await getBalanceRecord(this.body);
			if( status !== 200) return
			this.balanceList = data.data;
			if(this.balanceList.length){
				this.body.page_index += 1
			}
		},
		
		loadBottom(){
		    this.$refs.loadmore.onBottomLoaded();
		    this.$refs.loadmore.onTopLoaded();
		    this.loadMore()
		},
		
		
		async loadMore(){
		    const { data, status } = await getBalanceRecord(this.body);
		    if( status !== 200) return
		    if(data.data.length){
		        this.body.page_index += 1
		        this.balanceList = this.balanceList.concat(data.data);
		    }else{
		        window.toast("没有更多数据","txt");
		    }
		},
	}
}
</script>

<style lang='less' scoped>
	@import '~@/assets/styles/variable.less';
	@import '~@/assets/styles/handleMethods.less';
	@import '~@/assets/styles/reset.css';
    section{font-family:PingFangSC-Regular;font-weight:400;background: #fff}
	.no-order{width: 85px;height:78.5px;margin: 0 auto;margin-top:50%;margin-bottom: 50%}
	.no-order img{width: 100%;height: 100%}
	.no-order p{text-align: center;font-size:13px;font-family:PingFangSC-Medium;font-weight:500;color:rgba(207,207,207,1);line-height:18.5px;margin-top: 10.5px}
	.list{overflow-y: scroll; width: 100%;height: 100%;};
	.list ul{margin-bottom: 26px}
	.news-wrap{border-bottom: 1px solid #EEEEEE;padding: 13px 20px 13px 20px;}
	.balance-money{display: -webkit-box;display: -ms-flexbox;display: flex;justify-content: space-between;align-items: center}
	.text{font-family:PingFangSC-Medium;font-weight:500;color:rgba(51,51,51,1);font-size: 15px}
	.time{color:rgba(153,153,153,1);font-size: 13px;float: right;}
	.balance{color:rgba(51,51,51,1);font-size: 13px}
	.count-money{display: flex;align-items: center;}
	.money{font-family:PingFangSC-Medium;font-weight:500;color:rgba(51,51,51,1);font-size: 19px;}
</style>
